import request from '@/utils/request'

export function selectProjectList(params) {
  return request({
    url: '/api/v1.0/project/list',
    method: 'get',
    params:params
  })
}

export function selectAllProject() {
  return request({
    url: '/api/v1.0/project/list/all',
    method: 'get',
    params:{}
  })
}

export function selectProject(id) {
  return request({
    url: '/api/v1.0/project/'+id,
    method: 'get',
    params:{}
  })
}

export function selectProjectByNo(pno) {
  return request({
    url: '/api/v1.0/project/select',
    method: 'get',
    params:{pno:pno}
  })
}

export function addProject(data) {
  return request({
    url: '/api/v1.0/project/add',
    method: 'post',
    data: data
  })
}

export function updateProject(data) {
  return request({
    url: '/api/v1.0/project/update',
    method: 'post',
    data: data
  })
}

export function deleteProject(data) {
  return request({
    url: '/api/v1.0/project/delete',
    method: 'delete',
    data: data
  })
}
